import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ReferenceDataLabels } from '../../constants/reference-data-labels';
import { ReferenceDataOptionLists } from '../../constants/reference-data-option-lists';
import { ApplicationCase } from '../../models/api/application-case.model';
import { CaseRequestDto } from '../../models/dto/case-overview/case-request-dto.model';
import { CaseRequestsService } from '../../services/case-requests.service';
import { ApplicationHostTypeService } from '../../services/application-host-type.service';

@UntilDestroy()
@Component({
  selector: 'boi-case-requests',
  templateUrl: './case-requests.component.html',
  styleUrls: ['./case-requests.component.scss']
})
export class CaseRequestsComponent implements OnInit {
  @Input() public applicationCase: ApplicationCase;
  @Input() public showOnlyMostRecentHistoryStatus: boolean = false;
  @Output() public readonly goToCustomersTab = new EventEmitter();
  @Output() public readonly goToAgentDetails = new EventEmitter<string>();
  @Output() public readonly productTransfer = new EventEmitter<CaseRequestDto>();

  public caseRequests: CaseRequestDto[];

  public referenceDataLabels = ReferenceDataLabels;
  public referenceDataOptionLists = ReferenceDataOptionLists;
  public interfaceTypeCode: string;
  public expandedStateOfIllustrations = [];
  public areIllustrationsReady: boolean;
  public isBoiInterface: boolean;

  constructor(
    public readonly applicationHostTypeService: ApplicationHostTypeService,
    private readonly caseRequestsService: CaseRequestsService
  ) {
    this.interfaceTypeCode = this.applicationHostTypeService.getCode();
    this.isBoiInterface = this.interfaceTypeCode === 'boi';
  }

  ngOnInit(): void {
    this.getCaseRequests(true);
    this.expandedStateOfIllustrations[0] = true;
  }

  public onProductTransfer(caseRequest: CaseRequestDto): void {
    this.productTransfer.emit(caseRequest);
  }

  public toggleCaseDetails(index: number): void {
    this.expandedStateOfIllustrations[index] = !this.expandedStateOfIllustrations[index];
  }

  public trackCaseRequestStatus(index: number, caseRequest: CaseRequestDto): string {
    return caseRequest.CurrentStatusCode;
  }

  public isCaseRequestTypeESIS(caseRequest: CaseRequestDto): boolean {
    return caseRequest.RequestTypeCode === this.referenceDataOptionLists.SwitchRequestTypeEsis;
  }

  private longPollingGetCaseRequests(): void {
    timer(0, 5000)
      .pipe(
        untilDestroyed(this),
        switchMap(() => this.caseRequestsService.getCaseStatuses(this.applicationCase.CaseNumberAsHash))
      )
      .subscribe((caseStatuses) => {
        if (!this.isAnyStatusChanged(this.caseRequests, caseStatuses)) {
          this.getCaseRequests(false);
          this.caseRequestsService.updateApplicationCase$.next();
        }
      });
  }

  private getCaseRequests(withLongPolling: boolean): void {
    this.caseRequestsService.getCaseRequests(this.applicationCase.CaseNumberAsHash).subscribe((data) => {
      this.caseRequests = data;

      if (this.applicationHostTypeService.isBrokerInterfaceType() && withLongPolling) {
        this.longPollingGetCaseRequests();
      }
      this.areIllustrationsReady = this.caseRequestsService.areAllIllustrationsReady(this.caseRequests);
    });
  }

  private isAnyStatusChanged(cases: CaseRequestDto[], statuses): boolean {
    let res: boolean = true;
    cases.forEach((caseRequest) => {
      let current = statuses.find((item) => item.CaseRequestID == caseRequest.CaseRequestID);
      if (caseRequest.CurrentStatusCode !== current.StatusCode) res = false;
    });
    return res;
  }
}
